export default __webpack_public_path__ + "static/media/reacher2.16b32908.JPG";